import {IChangePasswordData} from '../../../api/api.types';

export interface IChangePasswordForm extends ng.IFormController {
  oldPassword: ng.INgModelController,
  newPassword: ng.INgModelController,
  repeatNewPassword: ng.INgModelController
}

export class ChangePasswordDialog {
  static $inject = ['$mdDialog'];

  private changePasswordData: IChangePasswordData;
  private changePasswordForm: IChangePasswordForm;

  constructor(private $mdDialog:ng.material.IDialogService) {
  }

  apply = () => {
    this.$mdDialog.hide(this.changePasswordData);
  };

  cancel = () => {
    this.$mdDialog.cancel();
  }
}



/** WEBPACK FOOTER **
 ** ./app/hydromet/userManagement/details/change-password-dialog.controller.ts
 **/